/**
 * Delayed Loading Module
 * Implements delayed loading functionality for DFP Ads (based on a scroll length)
 * version 2.0.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/delayedloading',[
    "jquery",
    "underscore",
    "utilities",
    "logging",
    "AdPlatforms/dfp",
    "AdModules/headerbidding"
], function($, _, utilities, logging, dfp, headerbidding) {
    "use strict";
    var _ModuleName = "DFP Delayed Loading Module";

    var _config = { }
    var _data = {
        slots: [],
        pageconfig: {}
    }

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function( config ) {
        $.extend(_config, config.delayedload);
    }

    /**
     * Kicks off the delayed load handler on window scroll if slots are defined and we've scrolled enough
     */
    var start = function( pageconfig ) {
        // Store page config
        _data.pageconfig = pageconfig;

        if (_data.slots.length > 0) {
            ;
            var throttled = _.throttle(_handleDelayedLoad, _config.throttle);
            $(window).scroll(throttled);
        } else {
            ;
        }
    }

    /**
     * Register an ad slot for delayed loading
     * @param {AdSlot} slot Ad slot object
     */
    var registerSlot = function( slot ) {
        _data.slots.push(slot);
        ;
    }

    /**
     * Check if page is eligible for delayed loading based on it's position value
     * @param {AdSlot} slot Ad Slot object
     */
    var isEligibleForDelayedLoad = function( slot ) {
        return _config.eligible.length > 0 && _config.eligible.includes(slot.position);
    }

    /**
     * Handle delayed load on scroll
     */
    var _delaylock = false;
    var _refreshcount = 0;
    var _handleDelayedLoad = function () {
        // If delayed loading lock enabled, skip handler
        if (_delaylock) return;

        // Check if we're ready to handle
        if(!_isReady()) return;

        // enable delayed loading resource lock
        _delaylock = true;
        var loading = [];
        for(var i = 0; i < _data.slots.length; i++) {
            var slot = _data.slots[i];
            if (!slot.loaded) {
                ;
                loading.push(slot);
            }
        }

        if (loading.length > 0) {
            if(dfp.loadSlots(loading, _data.pageconfig)) {
                ;

                // Create Ready Monitor for DFP Refresh
                var readyMonitorName = 'DFPDelayedRefresh' + (++_refreshcount);
                utilities.registerReadyMonitor(readyMonitorName, function () {
                    ;
                    // Call Refresh
                    dfp.refreshSlots(loading);

                    // disable delayed loading resource lock
                    _delaylock = false;
                });

                headerbidding.refresh(loading, readyMonitorName);
            } else {
                logging.error("Something went wrong loading the slots", _ModuleName);
            }
        } else {
            // enable delayed loading resource lock
            _delaylock = false;
        }
    }

    /**
     * Removes slot from being tracked
     */
    var removeSlot = function (slot) {
        try {
            var index = _data.slots.findIndex(function(s) { return s.id == slot.id; });
            if(index >= 0) {
                ;
                _data.slots.splice(index, 1);
                ;
            }                
        } catch (error) {
            logging.error("Failed to remove slot", _ModuleName);
            logging.error(error, _ModuleName);
        }
    }

    var _isReady = function() {
        return window.scrollY >= _config.offset;
    }

    return {
        init: init,
        start: start,
        registerSlot: registerSlot,
        enabled: (function() { return _config.enabled; }),
        isEligibleForDelayedLoad: isEligibleForDelayedLoad,
        removeSlot: removeSlot
    }
});
